var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46,23.9999981C46,11.8497362,36.1502647,2,24,2S2,11.8497362,2,23.9999981 c0,10.9809361,8.0452328,20.0824757,18.5627899,21.7326832V30.3608456h-5.5873995v-6.3608475h5.5873995v-4.8479843 c0-5.5162411,3.285614-8.5605383,8.3099442-8.5605383c2.4069748,0,4.9253273,0.4300356,4.9253273,0.4300356v5.4141502h-2.7751389 c-2.7349186,0-3.5857124,1.698494-3.5857124,3.4372082v4.1271286h6.1009712l-0.9745483,6.3608475h-5.1264229v15.3718357 C37.9547653,44.0824738,46,34.9809341,46,23.9999981z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMedium);
export default __webpack_public_path__ + "static/media/facebook--medium.b8ba73adc500d300293b4879a4c84633.svg";
export { ForwardRef as ReactComponent };